import { render, staticRenderFns } from "./fireFightingDocumentOrg.vue?vue&type=template&id=04edb9f8"
import script from "./fireFightingDocumentOrg.vue?vue&type=script&lang=js"
export * from "./fireFightingDocumentOrg.vue?vue&type=script&lang=js"
import style0 from "./fireFightingDocumentOrg.vue?vue&type=style&index=0&id=04edb9f8&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04edb9f8')) {
      api.createRecord('04edb9f8', component.options)
    } else {
      api.reload('04edb9f8', component.options)
    }
    module.hot.accept("./fireFightingDocumentOrg.vue?vue&type=template&id=04edb9f8", function () {
      api.rerender('04edb9f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/sdf/fireFightingDocumentOrg.vue"
export default component.exports